import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Link } from '@printdeal/ui-library';
import { FeatureToggle } from '@printdeal/feature-management/react';

// @ts-expect-error
import { selectors as customerSelectors } from '../../../../../store/slices/customerSlice';

const CreateQuoteLink = () => {
  const isCompany: boolean = useSelector(customerSelectors.isCustomerCompany);

  return (
    <FeatureToggle id="create_quote_for_business_customer">
      <FeatureToggle.Enabled>
        {isCompany ? (
          <Link
            as={GatsbyLink}
            to="request/new"
            variant="secondary"
            iconBefore="plus"
            data-cy="create-new-quote"
          >
            <FormattedMessage id="quotes.list.requestQuote" defaultMessage="Request quote" />
          </Link>
        ) : null}
      </FeatureToggle.Enabled>
      <FeatureToggle.Disabled>
        <Link
          as={GatsbyLink}
          to="request/new"
          variant="secondary"
          iconBefore="plus"
          data-cy="create-new-quote"
        >
          <FormattedMessage id="quotes.list.requestQuote" defaultMessage="Request quote" />
        </Link>
      </FeatureToggle.Disabled>
    </FeatureToggle>
  );
};

export default CreateQuoteLink;
